import React from 'react';
import { TableCell } from '../TableCell';
import ILink from '../../../../types/ILink';
import { ContentParagraph, ContentParagraphModifier } from '../../../../_lib/components/ContentParagraph';
import { Hyperlink, HyperlinkTarget } from '../../../atoms/Hyperlink';
import { Icons, SVG } from '../../../atoms/SVG';

type TableCellDescription = {
  label: string;
  description?: string;
  externalLink?: ILink | null;
  cellProperties?: TableCell;
};
export function TableCellDescription({ label, cellProperties, description, externalLink }: TableCellDescription) {
  return (
    <TableCell {...cellProperties} dataHead={label}>
      <>
        {description && (
          <ContentParagraph modifier={ContentParagraphModifier.MARGIN_BOTTOM}>{description}</ContentParagraph>
        )}
        {externalLink && (
          <Hyperlink
            className="tables__link tables__link--external-link"
            to={externalLink.url}
            external
            target={HyperlinkTarget.BLANK}
          >
            <SVG svgClass="tables__link-external-link-icon" svgSpriteId={Icons.EXTERNAL_LINK_ARROW} />
            {externalLink.name || externalLink.url}
          </Hyperlink>
        )}
      </>
    </TableCell>
  );
}
